(function () {
    'use strict';

    angular
        .module('eclipseApp.myAccount')
        .controller('manageDataCtrl', manageDataCtrl)

    manageDataCtrl.$inject = [
        '$rootScope',
        '$state',
        '$stateParams',
        '$window',
        'uteLocale',
        'uteModal',
        'commonService',
        'permissionsService',
        'manageDataService',
        'dataExtraAPIService'];

    function manageDataCtrl(
        $rootScope,
        $state,
        $stateParams,
        $window,
        uteLocale,
        uteModal,
        commonService,
        permissionsService,
        manageDataService,
        dataExtraAPIService) {
        /* jshint validthis:true */
        var madCtrl = this;

        madCtrl.isErrorModalOpen = false;

        activate();

        function activate() {
            madCtrl.topupsError = false;
            madCtrl.noTopups = false;
            madCtrl.renderAddedData = false;
            /*  Language  */
            madCtrl.language = uteLocale.language.toLowerCase();

            /* CTN drop-down and user details section */
            madCtrl.selectedBAN = $stateParams.selectedBAN || $rootScope.userInfo.selectedAccountNumber;
            madCtrl.selectedCTN = $stateParams.selectedCTN || $rootScope.userInfo.selectedSubscriberNo;

            madCtrl.ctnList = manageDataService.getCTNList();

            if (madCtrl.ctnList.length < 1) {
                // if no ctn list, then iterate and get it from commonService
                madCtrl.ctnList = getCtnListFromCommonService();
            }

            /* Bonus data Section */
            var dataExtras = dataExtraAPIService.getDataExtraList();

            if (dataExtras) {
                // if dataExtras is available, build the pland and bonus details using it
                /*Plan section*/
                // madCtrl.planSize = manageDataService.getPricePlanDetails();
                madCtrl.planSize = dataExtraAPIService.getPlanSize();
                madCtrl.planNameEN = dataExtraAPIService.getPlanName();
                madCtrl.planNameFR = dataExtraAPIService.getPlanNameFR();
                /* Total Data section - Bonus Value */
                getBonusDataSection(dataExtras);
            } else {
                // if dataExtras is not available, build the pland and bonus details by calling dataExtras API.
                manageDataService.getDataExtrasFromGenesis(madCtrl.selectedBAN, madCtrl.selectedCTN).then(function (response) {
                    if (_.has(response, 'data.content')) {
                        var bonusDetails = _.get(response, 'data.content');
                        getPlanDetailsSection(bonusDetails);
                        getBonusDataSection(bonusDetails.dataExtrasList);
                    } else {
                        prepareErrorModal();
                    }
                }, function (error) {
                    prepareErrorModal();
                });
            }

            /* Added Data section */
            getAddedDataSection();

            /* WCOC Eligibility */
            madCtrl.canManageAuthorizedUsers = checkIfWCOCEligible();
        }

        function getCtnListFromCommonService() {
            var ctns = [], accountDetails = commonService.accountDetails;
            for (var i = 0; i < accountDetails.length; i++) {
                if (accountDetails[i].accountNumber === madCtrl.selectedBAN) {
                    for (var j = 0; j < accountDetails[i].subscriberServices.length; j++) {
                        _.forEach(accountDetails[i].subscriberServices[j], function (value, key) {
                            if (key.toLowerCase() === 'wireless') {
                                ctns.push(value.subscriberNo);
                            }
                        });
                    }
                }
            }
            return ctns;
        }

        function getPlanDetailsSection(details) {
            if (_.has(details, 'planSize') && _.has(details, 'planSizeUOM')) {
                madCtrl.planSize = details.planSize.toString().concat(' ').concat(madCtrl.language === 'en' ? details.planSizeUOM.displayNameEn : details.planSizeUOM.displayNameFr);
            }
            madCtrl.planNameEN = details.planName;
            madCtrl.planNameFR = details.planNameFr;
        }

        function getBonusDataSection(dataExtras) {
            madCtrl.dataBonusList = _.filter(dataExtras, { category: 'bonus' });

            var cloneBonusList = _.cloneDeep(madCtrl.dataBonusList);
            madCtrl.totalBonusData = manageDataService.calculateTotalBonus(cloneBonusList);
        }

        function getAddedDataSection() {
            manageDataService.getAccountInfoFromGenesis().then(function (response) {
                if (_.has(response, 'data.content.accounts')) {
                    var selectedAccountContext = _.find(_.get(response, 'data.content.accounts'), { 'accountNumber': madCtrl.selectedBAN });
                    madCtrl.accountId = selectedAccountContext.accountId;
                    madCtrl.subscriptionId = getSubscriptionIdForCtnInContext(selectedAccountContext, madCtrl.selectedCTN);
                    if (madCtrl.accountId && madCtrl.subscriptionId) {
                        getAllTopups(madCtrl.accountId, madCtrl.subscriptionId);
                    } else {
                        prepareErrorModal();
                    }
                } else {
                    prepareErrorModal();
                }
            }, function (error) {
                prepareErrorModal();
            });
        }

        function getSubscriptionIdForCtnInContext(accounts, currentCTN) {
            var subscriptionObj = _.find(accounts.subscriptions, { 'subscriptionNumber': currentCTN });
            if (subscriptionObj) {
                if (_.has(subscriptionObj, 'subscriberInfo.firstName') && _.has(subscriptionObj, 'subscriberInfo.lastName')) {
                    // set the display names
                    madCtrl.displayName = subscriptionObj.subscriberInfo.firstName.toLowerCase() + ' ' + subscriptionObj.subscriberInfo.lastName.toLowerCase();
                }
                return subscriptionObj.subscriptionId;
            }
        }

        function getAllTopups(accountId, subscriptionId) {
            manageDataService.getAllTopUpsFromGenesis(accountId, subscriptionId).then(function (response) {
                if (response) {
                    if (response.status === 200) {
                        madCtrl.allTopups = response.data;

                        /* One time topup section */
                        buildOTTList(madCtrl.allTopups);

                        /* Billing Cycle end date for OTT */
                        buildBillingCycleForOTT(madCtrl.accountId);

                        /* Monthly Data topup section */
                        buildMDTList(madCtrl.allTopups);

                        /* For Total Data - OTT and MDT section */
                        buildTotalData();
                        madCtrl.renderAddedData = true;
                    }
                    else if (response.status === 204) {
                        madCtrl.noTopups = true;
                    }
                }
            }, function (error) {
                // handle error scenario for topups
                prepareErrorModal();
            });
        }

        function buildOTTList(topups) {
            madCtrl.ottList = _.filter(topups, { type: 'one-time' });
        }

        function buildBillingCycleForOTT(accountId) {
            var billingDetails = manageDataService.getBillingInfo();
            if (!_.get(billingDetails, 'cycleEndDate')) {
                manageDataService.getBillingInfoFromGenesis(accountId).then(function (response) {
                    if (response) {
                        if (_.get(response, 'data.content.billCycleEndDate')) {
                            var billEndDate = _.get(response, 'data.content.billCycleEndDate');
                            madCtrl.billCycleEndDate = moment(billEndDate).locale(madCtrl.language).format('LL');
                        }
                    }
                }, function (error) {
                    prepareErrorModal();
                });
            } else {
                madCtrl.billCycleEndDate = moment(billingDetails.cycleEndDate).locale(madCtrl.language).format('LL');
            }
        }

        function buildMDTList(topups) {
            madCtrl.mdtList = _.filter(topups, { type: 'monthly' });
        }

        function buildTotalData() {
            var ottListClone = _.cloneDeep(madCtrl.ottList);
            var mdtListClone = _.cloneDeep(madCtrl.mdtList);
            madCtrl.totalOTT = manageDataService.calculateTotalOTTAndMDT(ottListClone);
            madCtrl.totalMDT = manageDataService.calculateTotalOTTAndMDT(mdtListClone);
        }

        function prepareErrorModal() {
            madCtrl.topupsError = true;
            if (!madCtrl.isErrorModalOpen) {
                showErrorModal();
            }
        }

        function showErrorModal() {
            madCtrl.isErrorModalOpen = true;
            uteModal.open({
                templateUrl: 'modules/my-account/wireless/manage-data/manage-data.error.html',
                windowTemplateUrl: 'views/templates/modal/pop-up-window-modal.html',
                windowClass: 'manage-data-window-class',
                backdrop: 'static',
                controller: ['$scope', '$state', function ($scope, $state) {
                    var modalVm = this;
                    modalVm.close = function () {
                        $scope.$close();
                        madCtrl.isErrorModalOpen = false;
                        $state.go('myAccount.wireless', {
                            'accountNumber': madCtrl.selectedBAN,
                            'subscriberNo': madCtrl.selectedCTN,
                        });
                    };
                }],
                controllerAs: 'ctrl'
            });
        }

        function checkIfWCOCEligible() {
            // var isWcocProfileBRT = permissionsService.permissionDetail.isWcocBRT;
            var wcocWirelessBan = false;
            _.forEach($rootScope.userInfo.accounts, function (value, index) {
                wcocWirelessBan = madCtrl.selectedBAN === value.accountNumber &&
                    value.serviceName && value.serviceName.toLowerCase() === 'wireless' &&
                    value.status && value.status.toLowerCase() !== 'cancelled';
            });
            return ($rootScope.userInfo.profileType.owner || $rootScope.userInfo.profileType.groupId) && wcocWirelessBan;
        }

        // scope level functions

        madCtrl.reloadManageDataPage = function () {
            $state.go('myAccount.manageData', {
                selectedBAN: madCtrl.selectedBAN,
                selectedCTN: madCtrl.selectedCTN
            });
        }

        madCtrl.redirectToWcocPortal = function () {
            manageDataService.getJWTforWCOC().then(function (response) {
                $window.localStorage.setItem('wcocToken', response.data);
                var redirectionUri = $window.location.origin || $window.location.protocol + '//' + $window.location.hostname;
                redirectionUri = redirectionUri + '/web/wcoc/#/manage-users/' + uteLocale.language.toUpperCase() + '/F?entryId=D';
                $window.open(redirectionUri, '_self');
            }, function (error) {
                // error redirecting to WCOC portal
                prepareErrorModal();
            });
        }
    }
})();